<template>
  <div>
    <CoreContentArea
      class="flex flex-col justify-center"
    >
      <div
        v-if="!!data"
        class="flex flex-wrap flex-pad justify-around items-stretch items-center"
      >
        <!-- Card 1 -->
        <HomeCard
          icon="home"
          :title="data.card1Title"
          :inner-text="data.card1Text"
          :cta-text="data.card1CtaText"
          class="md:mr-2 my-8"
          :to="data.card1ExternalLink"
        />
        <HomeCard
          icon="envelope"
          :title="data.card2Link.fields.title"
          :inner-text="data.card2Text"
          :cta-text="data.card2CtaText"
          class="md:mx-2 my-8"
          :to="{ name: contentType(data.card2Link) }"
        />
        <HomeCard
          icon="tools"
          :title="data.card3Link.fields.title"
          :inner-text="data.card3Text"
          :cta-text="data.card3CtaText"
          class="md:ml-2 my-8"
          :to="{ name: contentType(data.card3Link) }"
        />
      </div>
    </CoreContentArea>
    <BlockFooter />
  </div>
</template>

<script>
import { home } from '@io';
import { BlockFooter } from '@c/Block';
import { contentType } from '@utils';
import HomeCard from './HomeCard';

export default {
  name: 'Home',

  components: {
    BlockFooter,
    HomeCard,
  },

  data: () => ({
    data: null,
  }),

  async created() {
    this.data = await home.get();
  },

  methods: {
    contentType,
  },
};
</script>

<style scoped>
/* .flex-pad::after {
  content: "";
  flex: auto;
  min-width: 24rem;
  max-width: 28rem;
  width: 26.5%;
  display: block;
} */
</style>
